import { useBookingStore } from "@booking/booking/store/useBookingStore";
import { preload } from "swr";
import useSWRImmutable from "swr/immutable";

import { getJSONWithCredentials } from "@/utils/swr";

import { APP_SETTING_ERRORS } from "./constants";
import { AppSetting, AppSettingResponse } from "./types";

const API_URL = `${import.meta.env.VITE_API_HOST}/api/app_settings`;

const fetchAppSetting = getJSONWithCredentials<AppSettingResponse>(
  APP_SETTING_ERRORS.GENERIC_ERROR,
  {},
);

export const preloadAppSetting = (): void => {
  preload(API_URL, fetchAppSetting);
};

export const useAppSettingQuery = () => {
  const { setAppSetting } = useBookingStore((state) => state.appSettingActions);
  const { data, error, isLoading } = useSWRImmutable(API_URL, fetchAppSetting);
  const appSetting = data?.data ?? ({} as AppSetting);

  if (Object.keys(appSetting).length) {
    setAppSetting(appSetting);
  }

  return {
    appSetting: data,
    error: (error as Error) || !!data?.errors.at(0),
    isLoading: isLoading,
  };
};
